<template>
  <div>
    <h2>{{ title }}</h2>
    <loading :active.sync="isLoading" :is-full-page="true"></loading>
    <template>
      <v-system-bar class="branch-data">
        <v-spacer></v-spacer>
        <div v-on:keypress.enter.prevent="getOurServiceTable(1)">
          <input-search
            :model="search" @update="searchInput"/>
        </div>
        <circle-button
          v-if="permissionOurService && permissionOurService.permission_id === permission.readWrite"
          @click.native="clearOurServiceData"/>
      </v-system-bar>
    </template>
    <template>
      <v-simple-table class="branch-data">
        <template v-slot:default>
          <thead>
          <tr>
            <th class="text-center" v-for="header in headers" :key="header.id">
              {{ header.text }}
            </th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(item,index) in dataTable" :key="item.id">
            <td width="5" align="center">{{((dataPaginate.current_page-1)*10)+(index+1)}}</td>
            <td>{{item.title_th}} ( {{item.title_en}} ) </td>
            <td width="40%" >{{item.intro_th}}</td>
            <td>{{item.updated_at | moment('DD-MM-YYYY')}}</td>
            <td>
              <a @click="showOurServiceData(item.id)">
                <icon-pencil />
              </a>
            </td>
          </tr>
          </tbody>
        </template>
      </v-simple-table>
    </template>
    <paginate :length="dataPaginate.last_page"
              :page="dataPaginate.current_page"
              @update="changePage">
    </paginate>
  </div>
</template>

<script>
    import CircleButton from "../../components/Button/CircleButton";
    import InputSearch from "../../components/Input/InputSearch";
    import IconPencil from "../../components/Icon/icon-pencil";
    import {mapState} from "vuex";
    import Paginate from "../../components/Layout/Paginate";
    import {permissionOurService, role} from "../../util/Permission";
    import Swal from 'sweetalert';
    import Loading from 'vue-loading-overlay';

    export default {
        name: "OurServiceTable",
      components: {Paginate, IconPencil, InputSearch, CircleButton, Loading},
      data(){
          return{
            title : 'Our Service',
            isLoading : false,
            headers: [
              { id: 1, text: "No." },
              { id: 2, text: "Title" },
              { id: 3, text: "Description" },
              { id: 4, text: "Update date" },
              { id: 5, text: "Edit" }
            ],
            dataTable :[],
            dataPaginate: {
              current_page: 1,
              from: 1,
              last_page: 1,
              per_page: 1,
              total: 1,
              to: 1
            },
            permission : null,
            search : '',
          }
        },

      created() {
          this.permission = role;
          this.getOurServiceTable(1);
      },
      computed: {
        permissionOurService,
        ...mapState({
          form: state => {
            return state.OurService.form;
          }
        })
      },
      methods:{
          getOurServiceTable(page){
            this.isLoading = true;
            this.$store.dispatch("OurService/getOurService",{
              page,
              search : this.search
            }).then(res=>{
              if(res.response_code == 200){
                this.dataTable = res.result.data;
                this.dataPaginate = {
                  current_page: res.result.current_page,
                  from: res.result.from,
                  last_page: res.result.last_page,
                  per_page: res.result.per_page,
                  total: res.result.total,
                  to: res.result.to
                }
              }
              this.isLoading = false;
            }).catch(()=>{
              Swal('','Cannot request our service data','error');
              this.isLoading = false;
            })
          },
        async changePage(val){
          this.isLoading = true;
          this.dataPaginate.current_page = val;
          await this.getOurServiceTable(this.dataPaginate.current_page);
          this.isLoading = false;
        },
        goToOurServiceEdit(){
            this.$router.push("/our-service/edit");
        },
        showOurServiceData(id){
          this.isLoading = true;
          this.$store.dispatch("OurService/showOurService",id).then(res=>{
            if(res.response_code == 200){
              this.$store.dispatch("OurService/setFormOurService",res.result).then(()=>{
                this.goToOurServiceEdit();
              })
            }
            this.isLoading = false;
          })
        },
        clearOurServiceData(){
            this.$store.dispatch("OurService/clearFormData").then(()=>{
              this.goToOurServiceEdit();
            });
        },
        searchInput(val){
          this.search = val;
        },
      },
    }
</script>

<style lang="scss" scoped>
  @import "../../assets/css/variables.scss";
  .branch-data {
    background-color: $background-theme;
    margin: $margin-search;
  }
</style>
